import React, { Component } from 'react'
import './Header.css'
import { Link, Redirect } from 'react-router-dom'
import UIkit from 'uikit'
import logoHeaderWeb from '../../utils/assets/images/logo-aps-benin-black.png'
import logoHeaderMobile from '../../utils/assets/images/logo-aps-benin-mobile.png'
import { connect } from 'react-redux'
import { fetchLogoutAction } from '../../actions/Authentification/Logout'

class Header extends Component {
  state = {
    isLogoutUser: false,
    isOldLoginCourtier: false,
    isCurrentLoginCourtier: localStorage.getItem("isCurrentLoginCourtier")
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.logoutMembers.isSuccess !== this.props.logoutMembers.isSuccess) {
      this.setState({ isLogoutUser: nextProps.logoutMembers.isSuccess })
    }
  }
  checkLogoutCourtier = () => {
    const { userLogoutAction } = this.props
    this.setState({ isOldLoginCourtier: true })
    localStorage.removeItem('isCurrentLoginCourtier')
    userLogoutAction()
  }
  removeSouscriptionOfCourtier = () => {
    const { userLogoutAction } = this.props
    this.setState({ isOldLoginCourtier: true })
    localStorage.removeItem('isCurrentLoginCourtier')
    localStorage.removeItem('souscripteurID')
    userLogoutAction()
  }
  checkLogoutUser = () => {
    const { userLogoutAction } = this.props
    userLogoutAction()
  }
  checkLogoutUserMobile = () => {
    const { userLogoutAction } = this.props
    userLogoutAction()
    UIkit.offcanvas.hide('#aps-toggle-menu-mobile')
  }
  checkCloseCanvas = () => {
    UIkit.offcanvas.hide('#aps-toggle-menu-mobile')
  }
  render() {
    const {logoutMembers, userIsSuccessLogin } = this.props
    const { isLogoutUser, isCurrentLoginCourtier, isOldLoginCourtier } = this.state

    return(
      <div>
        {(logoutMembers.isSuccess && isLogoutUser) &&
          <div>
            {isOldLoginCourtier 
              ?
                <Redirect to="/connexion-intermediaires" push/>
              :
                <Redirect to="/connexion" push/>
            }
          </div>
        }
        <div className="aps-on-scroll-up" data-uk-sticky="top: 120; animation: uk-animation-slide-top; bottom: #sticky-on-scroll-up">
          {/*Navbar on Web*/}
          <div className="uk-container-large aps-container-large aps-container-large-show-web">
            <div className="aps-header-container-navbar">
              <nav className="uk-navbar-container aps-header" data-uk-navbar>
                <div className="uk-navbar-left">
                  <Link className="uk-navbar-item uk-logo aps-container-logo" target="_blank" to="https://aps-benin.com">
                    <img className="state-1-2-x aps-logo" src={logoHeaderWeb} alt="logo" />
                  </Link>
                </div>
                <div className="uk-navbar-right">
                  <ul className="uk-navbar-nav aps-navbar">
                    {(userIsSuccessLogin && isCurrentLoginCourtier) && (
                      <li className="aps-navbar-nav-element-item" onClick={() => this.removeSouscriptionOfCourtier()}>
                        <div className="aps-pre-header-action-btn-right">
                          <a className="uk-button aps-btn-pre-header-full aps-btn-black" >Nouvelle souscription</a>
                        </div>
                      </li>
                    )}
                    <li className="aps-navbar-nav-element-item">
                      <div className="aps-pre-header-action-btn-right">
                        <Link className="uk-button aps-btn-custom-on-new" target="_blank" to="https://aps-benin.com">Aller au site</Link>
                      </div>
                    </li>
                    {userIsSuccessLogin && (
                      <li className="aps-navbar-nav-element-item">
                        <Link className="aps-navbar-item" to={{hash: '#'}}>Mon compte</Link>
                        <div className="uk-navbar-dropdown aps-navbar-dropdown">
                            <ul className="uk-nav uk-navbar-dropdown-nav">
                              {!isCurrentLoginCourtier && (
                                <li><Link className="aps-navbar-dropdown-item" to="/reglages">Réglages</Link></li>
                              )}
                              {!isCurrentLoginCourtier && (
                                <li className="uk-nav-divider"></li>
                              )}
                              {isCurrentLoginCourtier
                                ?
                                  <li>
                                    <button
                                      className="uk-button aps-btn-logout-header"
                                      onClick={() => this.checkLogoutCourtier()}
                                    >
                                      Déconnexion
                                    </button>
                                  </li>
                                :
                                  <li>
                                    <button
                                      className="uk-button aps-btn-logout-header"
                                      onClick={() => this.checkLogoutUser()}
                                    >
                                      Déconnexion
                                    </button>
                                  </li>
                              }
                            </ul>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
              </nav>
            </div>
          </div>
          {/*Pre-header on Mobile*/}
          <div style={{display:"none"}} className="uk-container-large aps-container-large aps-pre-header-mobile aps-pre-header-show-mobile">
            <div>
              <nav className="uk-navbar-container uk-navbar-transparent" data-uk-navbar>
                <div className="uk-navbar-left aps-navbar-left">
                  <Link className="aps-container-logo-mobile" target="_blank" to="https://aps-benin.com">
                    <img className="state-1-2-x-mobile aps-logo-mobile" src={logoHeaderMobile} alt="logo" />
                  </Link>
                </div>
                {/*Menu Mobile */}
                <div className="uk-navbar-right aps-navbar-right">
                  <Link className="uk-navbar-toggle aps-navbar-toggle"
                    to="#aps-toggle-menu-mobile" data-uk-toggle="{target: #aps-toggle-menu-mobile}">
                    <div className="aps-line-navbar-container">
                      <div className="aps-line-navbar"></div>
                      <div className="aps-line-navbar-milieu"></div>
                      <div className="aps-line-navbar"></div>
                    </div>
                    <div className="uk-text-center aps-navbar-menu">MENU</div>
                  </Link>
                </div>
              </nav>
            </div>
          </div>
        </div>
        {/*Toggle Menu on Mobile*/}
        <div id="aps-toggle-menu-mobile" data-uk-offcanvas="flip: true; overlay: true" className="aps-menu-toggle-container">
          <div className="uk-offcanvas-bar aps-toggle-container">
            <button className="uk-offcanvas-close aps-toggle-close" type="button"><span uk-icon="icon: close; ratio: 1" className="uk-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" ratio="1">
              <path fill="none" stroke="#000" strokeWidth="1.06" d="M16,16 L4,4"></path> <path fill="none" stroke="#000"
              strokeWidth="1.06" d="M16,4 L4,16"></path></svg></span>
            </button>
            <div className="aps-toggle-navbar-content">
              <div className="aps-toggle-navbar-btn-action">
                <Link className="uk-button aps-btn-pre-header-full aps-btn-pre-header-custom-header" target="_blank" to="https://aps-benin.com">Aller au site</Link>
              </div>
              {/*...*/}
              {userIsSuccessLogin && (
                <div>
                  <hr className="aps-btn-pre-header-divider" />
                  <div className="aps-footer-link-toggle-title-dashboard">
                    DASHBOARD
                  </div>
                  <div className="aps-footer-container-link-toggle" style={{paddingTop: "17px"}}>
                    <p className="aps-footer-link-toggle"><Link className="uk-link-text uk-text-left" onClick={() => this.checkCloseCanvas()} to="/souscripteur">Ma souscription </Link></p>
                    <p className="aps-footer-link-toggle"><Link className="uk-link-text uk-text-left" onClick={() => this.checkCloseCanvas()} to="/parrain">Mon lien de parrainage</Link></p>
                  </div>
                  <hr className="aps-btn-pre-header-divider-second" />
                  <div className="aps-pre-header-title-mobile">
                    <div className="uk-child-width-1-2 aps-pre-header-title-all" data-uk-grid>
                      <div className="aps-footer-container-link-toggle">
                        <p className="aps-footer-link-toggle"><Link className="uk-link-text uk-text-left" onClick={() => this.checkCloseCanvas()} to="/reglages">Réglages</Link></p>
                        <p className="aps-footer-link-toggle"><Link className="uk-link-text uk-text-left" to={{hash: '#'}} onClick={() => this.checkLogoutUserMobile()} data-uk-close>Déconnexion</Link></p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/*...*/}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const  mapStateToProps = ({ logoutMembers }) => {
  return {
    logoutMembers,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    userLogoutAction: () => dispatch(fetchLogoutAction()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/index.js